var React = require('react');

function Active (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"cx":"63","cy":"63","r":"33","fill":"fill","key":0}),React.createElement("path",{"fill":"fill","d":"M62.692 26.975a36 36 0 1 1-36 36 36 36 0 0 1 36-36m0-10a46 46 0 1 0 46 46 46.052 46.052 0 0 0-46-46z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M62.692 34.975a28 28 0 1 1-28 28 28.032 28.032 0 0 1 28-28m0-8a36 36 0 1 0 36 36 36 36 0 0 0-36-36z","key":2}),React.createElement("circle",{"cx":"62.5","cy":"62.5","r":"19.5","fill":"currentColor","key":3}),React.createElement("circle",{"cx":"63","cy":"63","r":"63","fill":"none","key":4})]));
}

Active.defaultProps = {"viewBox":"0 0 126 126"};

module.exports = Active;

Active.default = Active;
